import { render } from "./Login.vue?vue&type=template&id=24122060"
import script from "./Login.modal.js?vue&type=script&lang=js"
export * from "./Login.modal.js?vue&type=script&lang=js"

import exportComponent from "/Users/danilomeulens/Projects/_sandbox/simpsonbay_geneology/source/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__